import { Routes } from '@angular/router';
import { DashboardComponent } from '../../dashboard/dashboard.component';
import { AnalysisComponent  } from '../../analysis/analysis.component';
import { ReportsComponent } from '../../reports/reports.component';
import {DownloadsComponent} from '../../downloads/downloads.component';
import {ActionPlanComponent} from '../../actionplan/actionplan.component';
import {AddAssignUserComponent} from '../../addassignuser/addassignuser.component';
import { AddAuditerComponent } from 'app/add-auditer/add-auditer.component';
import { AddGmComponent } from 'app/add-gm/add-gm.component';
import { ModuelsDetailsComponent } from 'app/dashboard/ModuelsDetails/ModuelsDetails.component';
import { TestResultsComponent } from 'app/TestResults/TestResults.component';
import { LabReportsComponent } from 'app/LabReports/LabReports.component';
import { AddmeasureitemsComponent } from 'app/addmeasureitems/addmeasureitems.component';
import { AddusermeasurerComponent } from 'app/addusermeasurer/addusermeasurer.component';
import { MeasurerReportsComponent } from 'app/measurer-reports/measurer-reports.component';
import { ChatAiComponent } from 'app/ChatAi/ChatAi/ChatAi.component';
import { MonitiringDashboardComponent } from 'app/monitiring-dashboard/monitiring-dashboard.component';



export const GmLayoutRoutes: Routes = [
  { path: 'dashboard-gm', component: DashboardComponent},
  { path: 'dashboard-gm/details/:id', component: ModuelsDetailsComponent },
   { path: 'analysis-gm', component: AnalysisComponent },
  { path: 'reports-gm', component: ReportsComponent },
  { path: 'downloads-gm', component: DownloadsComponent },
  { path: 'testresults-gm', component: TestResultsComponent },
  { path: 'labreport-gm', component: LabReportsComponent },
  { path: 'actionplan-gm', component: ActionPlanComponent },
  { path: 'addassignuser-gm', component: AddAssignUserComponent },
  { path: 'addpartner-gm', component: AddGmComponent },
  { path: 'addauditer-gm', component: AddAuditerComponent },
  { path: 'addassigner-gm', component: AddAssignUserComponent },
  { path: 'addmeasureitems-gm', component: AddmeasureitemsComponent },
  { path: 'addusermeasurer-gm', component: AddusermeasurerComponent },
  { path: 'measurerreports-gm', component: MeasurerReportsComponent },
  { path: 'dr-mo-ai-gm', component: ChatAiComponent },
  { path: 'monitiringdashboard-gm', component: MonitiringDashboardComponent },

  

];
